const VIDEO_MIME_TYPES = ['video/mp4', 'video/3gpp', 'video/3gp'];
const VIDEO_EXTENSIONS = ['.mp4', '.3gp'];

const fileName = (file) => (file?.name || '').toLowerCase();

export const uploadFileKind = (file) => {
  if (!file) return 'other';
  const type = (file.type || '').toLowerCase();
  const name = fileName(file);
  if (type.startsWith('image/')) return 'image';
  if (type === 'application/pdf' || name.endsWith('.pdf')) return 'pdf';
  if (VIDEO_MIME_TYPES.includes(type) || VIDEO_EXTENSIONS.some((ext) => name.endsWith(ext))) return 'video';
  return 'other';
};

export const isAllowedMediaUpload = (file) => ['image', 'pdf', 'video'].includes(uploadFileKind(file));

export const dropzoneRejectionKey = (rejections) => {
  const code = rejections?.[0]?.errors?.[0]?.code;
  if (code === 'too-many-files') return 'too_many_files';
  return 'invalid_file_type';
};

export const storedMediaKind = (item) => {
  const mime = (item?.mime_type || '').toLowerCase();
  const name = (item?.original_name || item?.name || '').toLowerCase();
  if (!item?.url) return 'file';
  if (mime.startsWith('image/')) return 'image';
  if (mime.startsWith('video/')) return 'video';
  if (mime === 'application/pdf' || name.endsWith('.pdf')) return 'pdf';
  return 'file';
};
